module.exports = __webpack_public_path__ + "static/parade-awards-opt-ea086f658750027fe7251bb81a668a98.jpg";